import { Component, Inject, OnInit } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialog, MatDialogConfig, MatDialogRef } from '@angular/material/dialog';
import { ModalQuestionarioImportaDadosComponent } from '../modal-questionario-importa-dados/modal-questionario-importa-dados.component';
import { Router } from '@angular/router';

@Component({
  selector: 'app-modal-questionario-nova-versao',
  templateUrl: './modal-questionario-nova-versao.component.html',
  styleUrls: ['./modal-questionario-nova-versao.component.scss']
})
export class ModalQuestionarioNovaVersaoComponent implements OnInit {
  private currentDialogRef: MatDialogRef<any>;

  constructor(
    private dialogRef: MatDialogRef<ModalQuestionarioNovaVersaoComponent>,
    private matDialog: MatDialog,
    @Inject(MAT_DIALOG_DATA) public data: any ,
    private router: Router
  ) { }

  ngOnInit(): void {
  }

  public Sim() {

    if(this.data.source === 'importarArquivo')
    {
      this.dialogRef.close();
      this.router.navigate([`importacao-arquivo-questionario`]);
    }
    else
    {
      this.dialogRef.close();
      const dialogConfig = new MatDialogConfig();
      dialogConfig.id = 'modal2-component';
      dialogConfig.width = '650px';
      dialogConfig.hasBackdrop = true;
      dialogConfig.disableClose = true;
    
      const modal = this.matDialog.open(ModalQuestionarioImportaDadosComponent, dialogConfig);
      modal.afterClosed().subscribe((data) => {
        if(data){
  
      }
    })
  }
  }

  public Nao() {
    this.dialogRef.close();
  }

  public cancelar() {
    this.dialogRef.close();
  }

}
